import { createAction, props } from '@ngrx/store';
import { Group } from '@shared/models/group';

export const updatePartnerDetails = createAction(
  '[Partner Details] Update Partner Details',
  props<{ group: Partial<Group>; updateAllCustomers?: boolean }>(),
);

export const updatePartnerDetailsSuccess = createAction(
  '[Partner Details] Update Partner Details Success',
  props<{ group: Group }>(),
);

export const updatePartnerDetailsFailure = createAction(
  '[Partner Details] Update Partner Details Failure',
  props<{ error: any; group: Partial<Group> }>(),
);
